"use strict";
//Italian
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Ingresso',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Produzione',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Annulla',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Salvare',
  'BACK-BTN-LABEL': 'Indietro',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Muto',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Tenere',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Tastiera',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Trasferimento',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nuova chiamata',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Appendere',
  'CALLLIST-NOCALL' : 'No Chiamata attiva',
  'CANCEL-BTN-LABEL' : 'Annulla',
  'EMAIL-PLACEHOLDER' : 'Indirizzo email',
  'INCOMINGCALL-HEADER' : 'Chiamata in arrivo',
  'INCOMINGCALL-ACCEPT' : 'Accettare',
  'INCOMINGCALL-DECLINE' : 'Declino',
  'INCOMINGCALL-VOICEMAIL' : 'Invia ad Voicemail',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Inserisci lindirizzo email',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'la password',
  'LOGIN-CHECKBOX-LABEL' : 'Ricordati di me',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Ha dimenticato la password?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Registrati',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Inserisci il tuo indirizzo e-mail per reimpostare la password.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Si prega di inserire la password completa',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Inserisci e-mail valido',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Le password devono essere identiche',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'Resettare',
  'LOGIN-RESETPW-INFO-TEXT' : ', Si prega di cambiare la password. La password deve contenere almeno una lettera, senza spazi bianchi, non iniziare con @, e 8 o più caratteri.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Nuova password',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'ripeti la password',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Cambiamento',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Annulla',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Visualizzare gli avvisi',
  'SETTINGS-VERSION' : 'versione ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Aiuto Documentazione',
  'SETTINGS-CHECKBOX-LABEL' : 'consentire',
  'SETTINGS-CHECKBOX-HEADER' : 'Sempre in cima?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Chiudi Avvisi',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Disconnettersi',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Estensione',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Suoneria',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Dispositivo di Input',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Dispositivo di Uscita',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Interfaccia Tema',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Lingua dellinterfaccia',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Indietro',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Pulire',
  'CALLHISTORY-HEADER' : 'Storia',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Non chiamate',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'impostazioni',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'pulire',
  'ALERTLOG-HEADER' : 'Avvisi',
  'ALERTLOG-NO-ALERT-MSG' : 'Nessun avviso disponibile',
  'UTILITIES-STATUS-ONHOLD' : 'In attesa',
  'UTILITIES-STATUS-MUTED' : 'smorzato',
  'UTILITIES-STATUS-ACTIVE' : 'Attivo',
  'UTILITIES-STATUS-DIALING' : 'Composizione',
  'ALERTITEM-HEADING-LOGIN' : 'Accesso',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Il nome utente o la password sono errati.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Perso la connessione di rete. Controllare lo stato della connessione.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Inserire un numero da chiamare',
  'CALLDETAILS-HOLD' : 'In attesa',
  'CALLDETAILS-MUTED': 'smorzato',
  'CALLLIST-STATUS-ACTIVE': 'Attivo',
  'CALLLIST-STATUS-DIALING': 'composizione',
  'CALLHISTORY-STATUS-FAILED': 'fallito',
  'HEADING-STATUS-CONNECTED' : 'Collegato',
  'HEADING-STATUS-OFFLINE' : 'disconnesso',
  'BLIND-BTN-LABEL': 'Cieco',
  'ATTENDED-BTN-LABEL': 'Frequentato',
  'SOFTPHONE-DTMF-COMMANDS': "Inserisci numero",
  'ARIA-LOGIN-SIGNIN-BTN': "Entra tasto",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Pulsante Password dimenticata",
  'ARIA-CANCEL-BTN': "pulsante Annulla",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "Pulsante Ripristina la password",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Non adesso Pulsante",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Tasto indietro',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'pulsante Cancella cronologia',
  'ARIA-SETTINGS-LOGOUT-BTN': "pulsante Logout",
  'ARIA-SETTINGS-VIEWALERT-BTN': "pulsante Visualizza avvisi",
  'ARIA-SETTINGS-HELPDOC-BTN': "Aiuto tasto documentazione",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "pulsante Cambia password",
  'ARIA-BACKSPACE-BTN': 'Bpulsante Backspace',
  'ARIA-DIALING-INPUT-FIELD': 'campo di inserimento di composizione',
  'ARIA-HEADER': 'Intestazione',
  'ARIA-CLEAR-ALERTS-BUTTON': 'pulsante Cancella avvisi',
  'ARIA-ALERT-LIST': 'lista Alert',
  'ARIA-CHECKBOX': 'casella di controllo',
  'ARIA-SAVE-BTN': 'pulsante Salva',
  'ARIA-INPUT-FIELD': 'campo di immissione',
  'ARIA-INPUT': 'Ingresso',
  'ARIA-KEYPAD': 'tastiera',
  'ARIA-KEY': 'Chiave',
  'ARIA-AUDIO-SLIDER': 'cursore Audio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'cursore di controllo Audio',
  'ARIA-MENU-ITEM': 'Elemento del menu',
  'ARIA-DROP-DOWN-MENU': 'Menu a discesa',
  'ARIA-BADGE-BUTTON': 'pulsante Badge',
  'ARIA-CALL-DETAIL': 'dettaglio delle chiamate',
  'ARIA-OPEN-SETTINGS-BUTTON': 'pulsante Impostazioni aperte',
  'UPDATE-HEADER': 'Aggiornamento disponibile',
  'UPDATE-MSG': 'Volete riavviare lapplicazione ora?',
  'UPDATE-POSTPONE-BUTTON': 'rinviare (1 min)',
  'UPDATE-UPDATE-BUTTON': 'Aggiornare',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'rimandare Pulsante',
  'ARIA-UPDATE-UPDATE-BUTTON': 'Aggiornamento Button',
  'ACTIVECALL-STATUS-RINGING': 'suono',
  'ACTIVECALL-STATUS-ACTIVE': 'Attivo',
  'ACTIVECALL-STATUS-DIALING': 'composizione',
  'ACTIVECALL-STATUS-FAILED': 'fallito',
  'LOGIN-INPUT-SHOW': 'Mostrare',
  'LOGIN-INPUT-HIDE': 'nascondere',
  'CALLHISTORY-TODAY': 'Oggi',
  'CALLHISTORY-YESTERDAY': 'Ieri',
  'ALERT_FORGOT_PASSWORD': 'Ha dimenticato la password',
  'ALERT_SETTINGS_WILL_APPLY': 'chiamate attive; impostazioni vengono applicate quando è inattivo.',
  'ALERT_DIALING_OPTIONS': 'Opzioni di composizione',
  'ALERT_DIALING_OPTIONS_BODY': 'Manca quadrante opzioni piano',
  'ALERT_LOGIN': 'Accesso',
  'ALERT_SOFTPHONE_EXTENSION': 'No estensione softphone',
  'ALERT_MORE_INFORMATION': 'Per ulteriori informazioni visitare:',
  'ALERT_LOST_CONNECTION': 'Perso la connessione di rete. Controllare lo stato della connessione.',
  'ARIA-PLAY-BTN': 'pulsante di riproduzione',
  'ARIA-STOP-BTN': 'pulsante stop',
  'CONTACTS-STATUS-ONLINE': 'in linea',
  'CONTACTS-STATUS-OFFLINE': 'disconnesso',
  'CONTACTS-STATUS-BUSY': 'Occupato',
  'CONTACTS-STATUS-UNKNOWN': 'Sconosciuto',
  'LABELLEDINPUT-LABEL-EMAIL': "Indirizzo email",
  'LABELLEDINPUT-LABEL-PASSWORD': "Parola d'ordine",
  'LABELLEDINPUT-LABEL-TEXT': "Testo",
  'LABELLEDINPUT-HINT-EMAIL': "Inserire un indirizzo email valido al di sotto.",
  'LABELLEDINPUT-HINT-PASSWORD': "Inserire una password valida sotto.",
  'LABELLEDINPUT-HINT-TEXT': "Inserire il testo di seguito.",
  'ARIA-ICON-AREA': 'icona Area',
  'SETTINGS-ADVANCED-LOGGING': "Registrazione avanzata",
  'APPMENU-SETTINGS-BTN-LABEL': "Apri Impostazioni",
  'APPMENU-HELP-BTN-LABEL': "Guida alla documentazione",
  'APPMENU-LOGOUT-BTN-LABEL': "Logout",
  'APPMENU-VERSION': "versione ",
  'HEADER-SETTINGS-TITLE': "Impostazioni",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Notifiche",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Aspetto",
  'SETTINGS-CONTACTS-BTN-LABEL': "Contatti",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Risoluzione dei problemi",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Regolare come ricevete gli aggiornamenti.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Cambiare l'aspetto dell'applicazione.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importa i tuoi contatti.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Strumenti per aiutarti a scoprire cosa c'è di sbagliato",
  'ARIA-BACK-BTN-LABEL': "Indietro",
  'HEADER-BACK-ARIA-LABEL' : 'indietro',
  'ENTITYLIST-SEARCH-FOUND': "trovato.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "elementi",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Nuovo gruppo',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Nessun contatto trovato',
  'ENTITYLIST-TRY-IMPORTING': 'Provare ad importare o aggiungere un contatto.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Importare',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Immettere il numero da inviare o importare nellelenco dei contatti nelle impostazioni.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Cerca i contatti",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Aggiungi un numero',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Nessuna informazione di contatto',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Aggiungi un numero per iniziare',
  'ARIA-CARD-DETAILS-EDIT': 'Modifica',
  'ARIA-CARD-DETAILS-DELETE': 'Elimina',
  'SETTINGS-DEVICES-BTN-LABEL': "dispositivi",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Modifica il modo in cui i dispositivi sono configurati.",
  'HEADER-CONTACTS-ARIA-LABEL' : "contatti",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Risoluzione dei problemi",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Attiva la registrazione avanzata",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Quando abilitato l'applicazione creerà registri avanzati per aiutare a diagnosticare gli errori di applicazione.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Registrazione avanzata',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Avvisi",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Visualizza Avvisi",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Accedere a un record di avvisi e registri.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Suoneria",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Modificare la suoneria per le chiamate vocali in arrivo.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Predefinito",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Leggero",
  'APPMENU-DARK-THEME-BTN-LABEL': "Buio",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Sempre in cima",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Quando abilitato, l'applicazione verrà sempre visualizzata sopra le altre applicazioni.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Sempre in cima?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Tema",
  'SETTINGS-THEMES-DESCRIPTION': "Temi modificano l'aspetto generale dell'applicazione.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Lingua",
  'SETTINGS-LANGUAGE-DESCRIPTION': "La modifica della lingua lo modifica durante l'applicazione.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Dispositivo",
  'SETTINGS-CATEGORY-HEADER-CONTACTS': "Contatti",
  'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Aspetto",
  'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Notifiche",
  'SETTINGS-INPUT-DEVICE-TITLE': "Dispositivo di input",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Impostare il dispositivo audio da utilizzare per l'immissione.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Dispositivo di uscita",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Impostare il dispositivo audio da utilizzare per l'output.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importa i tuoi contatti",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Seleziona l'opzione qui sotto per importare i contatti.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Esempio CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Premendo il pulsante in basso verrà scaricato un file CSV di esempio.",
  'SETTINGS-CONTACTS-BACKUP': 'Di Riserva',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Premendo il pulsante in basso verrà scaricato un backup CSV dei tuoi contatti. Questo è consigliato prima delle importazioni.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Scarica Backup',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importati",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Importare",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Scarica Backup',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Aggiungi contatto',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Annulla",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Elimina",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Sei sicuro di voler eliminare questo contatto?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Completare questa azione rimuoverà permanentemente le informazioni del contatto corrente. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Un campo nel modulo sottostante presenta un errore.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Informazione personale',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Nome di battesimo',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Inserisci nome',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Cognome',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Inserisci cognome',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Azienda',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Immettere il nome della società',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Numeri di telefono',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Aggiungi telefono',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Annulla',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Salvare',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Nuovo contatto',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Modifica il contatto',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Questo campo non può essere lasciato in bianco.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Numero',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Inserisci un numero di 10 cifre valido',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Inserisci numero...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'preferito?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Casa',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Attività commerciale',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobile',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Altro',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Etichetta',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Selezionare il numero da chiamare',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Preferito',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Inserisci un numero valido'
  };
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-it.js